import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {Router} from '@angular/router';
import 'rxjs/add/operator/do';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse, HttpXsrfTokenExtractor
} from '@angular/common/http';
import {OperatingStandardService} from './operating-standard.service';
import 'rxjs/add/operator/map';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private cookie: CookieService,
              private tokenExtractor: HttpXsrfTokenExtractor,
              private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const operatingStandardService = this.injector.get(OperatingStandardService);
    const headerName = 'X-XSRF-TOKEN';
    const token = this.tokenExtractor.getToken() as string;

    let reqTemp = req;
    if (token !== null && !req.headers.has(headerName)) {
      reqTemp = req.clone({
        headers: req.headers.set(headerName, token)
      });
    }
    // set('Cookie', this.cookie.getAll().toString())

    return next.handle(reqTemp)
      .do((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.headers.get('NOTIFY-ME')) {
              operatingStandardService.notificationCountManager(event.headers.get('NOTIFY-ME'));
            }
          }
        }
      )
      .catch(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            localStorage.setItem('Authenticated', 'false');
            localStorage.removeItem('User');
            this.router.navigate(['signin']);
          }
        }
        return Observable.throw(err);
      });
  }

}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/error-interceptor.service.ts